/**
 * API 유틸리티
 * 중앙화된 API URL + fetch 헬퍼
 */

export function getApiBaseUrl(): string {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
        return `${protocol}//${hostname}:8001`;
    }
    return 'http://localhost:8001';
}

export function getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem('proposalcraft_access_token');
    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}

/**
 * 인증 포함 fetch 래퍼
 */
export async function apiFetch(
    path: string,
    options: RequestInit = {},
    signal?: AbortSignal,
): Promise<Response> {
    const url = `${getApiBaseUrl()}${path}`;
    return fetch(url, {
        ...options,
        signal,
        headers: {
            ...getAuthHeaders(),
            ...options.headers,
        },
    });
}
